document.addEventListener("DOMContentLoaded", function () {
  // только мобилка
  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  // флаг: уже инициализировали модалку или нет
  let mobileSearchBooted = false;

  // ================= ИНИЦИАЛИЗАЦИЯ МОБИЛЬНОЙ МОДАЛКИ =================
  function initMobileSearch() {
    if (!isMobile()) return;

    const headerSearch = document.querySelector(".header__search");
    const headerInput  = headerSearch?.querySelector(".js-search-input");
    if (!headerSearch || !headerInput) return;

    // запоминаем, где блок поиска стоял изначально
    const headerParent      = headerSearch.parentElement;
    const headerNextSibling = headerSearch.nextSibling;

    /* ---------- 1. СОЗДАЁМ МОДАЛКУ В DOM ---------- */

    const modal = document.createElement("div");
    modal.id = "clb-mobile-search-modal";
    modal.className = "clb-mobile-search-modal";
    modal.setAttribute("aria-hidden", "true");

    modal.innerHTML = `
      <div class="clb-mobile-search-modal__backdrop"></div>
      <div class="clb-mobile-search-modal__panel">
        <div class="clb-mobile-search-modal__top">
          <button type="button" class="clb-mobile-search-close" aria-label="Закрыть">✕</button>
          <div id="clb-mobile-search-slot" class="clb-mobile-search-slot"></div>
        </div>

        <div class="clb-mobile-search-content" id="clb-mobile-search-content">
          <div class="clb-mobile-search-history">
  <div class="search-history-header">
    <div id="clb-mobile-history-title"
         class="clb-mobile-section-title">
      История поиска
    </div>
    <button type="button" id="clb-mobile-clear-history" class="clear-history-btn">
      Очистить все
    </button>
  </div>
  <ul id="clb-mobile-history-list"></ul>
</div>

<div id="clb-mobile-recs-title"
     class="clb-mobile-section-title">
  Рекомендации
</div>
<ul id="clb-mobile-recs-list" class="recommendation-list"></ul>

        </div>
      </div>
    `;
    document.body.appendChild(modal);

    const modalBackdrop   = modal.querySelector(".clb-mobile-search-modal__backdrop");
    const modalPanel      = modal.querySelector(".clb-mobile-search-modal__panel");
    const closeBtn        = modal.querySelector(".clb-mobile-search-close");
    const searchSlot      = modal.querySelector("#clb-mobile-search-slot");
    const contentBlock    = modal.querySelector("#clb-mobile-search-content");
    const historyTitle    = modal.querySelector("#clb-mobile-history-title");
    const recsTitle       = modal.querySelector("#clb-mobile-recs-title");
    const historyList     = modal.querySelector("#clb-mobile-history-list");
    const recsList        = modal.querySelector("#clb-mobile-recs-list");
    const clearHistoryBtn = modal.querySelector("#clb-mobile-clear-history");

    if (!searchSlot || !contentBlock || !historyList || !recsList) return;
    
    /* ---------- 2. СТИЛИ ДЛЯ МОДАЛКИ ---------- */

    const style = document.createElement("style");
    style.textContent = `
      @media (max-width: 768px) {
        body.clb-mobile-search-open {
          overflow: hidden;
        }

        .clb-mobile-search-modal {
          position: fixed;
          inset: 0;
          z-index: 10000;
          display: none;
        }

        .clb-mobile-search-modal.is-open {
          display: block;
        }
/* ВНУТРЕННИЙ ВИД поля поиска в модальной мобилке */
.clb-mobile-search-slot .js-search-input {
  background-color: #8068b9;   /* светлее фон внутри поля */
  color:rgb(255, 255, 255);              /* цвет текста запроса */
  border-radius: 999px;        /* если хочешь более "пилюльное" поле */
  border: 1px solid #e5e7eb;   /* мягкая рамка */
}

/* Цвет placeholder’а "Поиск Colibri" */
.clb-mobile-search-slot .js-search-input::placeholder {
  color: #d1d5db;  /* мягкий светло-серый, а не чёрно-серый */
  opacity: 1;
}

        .clb-mobile-search-modal__backdrop {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.35);
        }

        .clb-mobile-search-modal__panel {
          position: absolute;
          inset: 0;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          padding: 8px 10px 16px;
        }

        /* ВЕРХ МОДАЛКИ — ФИОЛЕТОВАЯ ПОЛОСА + ПОИСК */
        .clb-mobile-search-modal__top {
          display: flex;
          align-items: center;
          gap: 8px;
          margin: -8px -10px 10px;
          padding: 10px 12px 14px;
          background: #5b3ba8;
          border-bottom-left-radius: 18px;
          border-bottom-right-radius: 18px;
        }

        .clb-mobile-search-close {
          border: none;
          background: transparent;
          font-size: 18px;
          padding: 4px 6px;
          color: #ffffff;
        }

        .clb-mobile-search-slot {
          flex: 1;
        }

        .clb-mobile-search-content {
          flex: 1;
          overflow-y: auto;
        }

        .clb-mobile-search-history {
          padding: 4px 0 8px;
          border-bottom: 1px solid #e5e7eb;
        }

        .clb-mobile-search-history .search-history-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
        }
.clb-mobile-search-history .search-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.clb-mobile-section-title {
  font-size: 13px;
  font-weight: 600;
  margin: 0;
}

        .clb-mobile-search-history ul {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
        }

        .clb-mobile-search-history li {
          background: #f5f5f5;
          padding: 5px 8px;
          border-radius: 9px;
          font-size: 12px;
          cursor: pointer;
          display: flex;
          align-items: center;
        }

        .clb-mobile-search-history li button {
          margin-left: 5px;
          border: none;
          background: transparent;
          cursor: pointer;
        }

        #clb-mobile-recs-list.recommendation-list {
          list-style: none;
          padding: 8px 0 0;
          margin: 0;
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        #clb-mobile-recs-list li {
          width: calc(50% - 4px);
          background: #f5f5f5;
          border-radius: 12px;
          padding: 8px;
          font-size: 13px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        #clb-mobile-recs-list img {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          object-fit: cover;
          margin-bottom: 4px;
        }

        #clb-mobile-recs-list span {
          font-size: 11px;
          text-align: center;
        }

        /* когда печатаем в поиске — спрятать историю/рекомы */
        .clb-mobile-search-modal.typing #clb-mobile-search-content {
          display: none;
        }
      }
    `;
    document.head.appendChild(style);

    /* ---------- 3. ПЕРЕВОДЫ ЗАГОЛОВКОВ ---------- */

    function translateTitles() {
      const lang = document.documentElement.lang || "en";
      const dict = {
        en: { history: "Search history", recs: "Recommendations", clear: "Clear all" },
        fr: { history: "Historique de recherche", recs: "Recommandations", clear: "Tout effacer" },
        nl: { history: "Zoekgeschiedenis", recs: "Aanbevelingen", clear: "Alles wissen" },
        ru: { history: "История поиска", recs: "Рекомендации", clear: "Очистить всё" },
        de: { history: "Suchverlauf", recs: "Empfehlungen", clear: "Alles löschen" }
      };
      const t = dict[lang] || dict.en;
      if (historyTitle) historyTitle.textContent = t.history;
      if (recsTitle)    recsTitle.textContent    = t.recs;
      if (clearHistoryBtn) clearHistoryBtn.textContent = t.clear;
    }

    /* ---------- 4. ИСТОРИЯ ПОИСКА ---------- */

    function loadHistory() {
      const history = JSON.parse(localStorage.getItem("searchHistory") || "[]");
      historyList.innerHTML = history.slice(0, 10).map((q) => {
        const trimmed = q.length > 18 ? q.slice(0, 15) + "..." : q;
        return `
          <li class="clb-search-history-item" data-query="${q}">
            <span>${trimmed}</span>
            <button type="button" data-item="${q}">×</button>
          </li>
        `;
      }).join("");

      if (clearHistoryBtn) {
        clearHistoryBtn.style.display = history.length ? "inline-block" : "none";
      }
    }

    function saveHistory(query) {
      const q = query.trim();
      if (!q) return;
      let history = JSON.parse(localStorage.getItem("searchHistory") || "[]");
      history = history.filter((x) => x !== q);
      history.unshift(q);
      if (history.length > 10) history = history.slice(0, 10);
      localStorage.setItem("searchHistory", JSON.stringify(history));
      loadHistory();
    }

    function clearHistory() {
      localStorage.removeItem("searchHistory");
      loadHistory();
    }

    /* ---------- 5. РЕКОМЕНДАЦИИ ---------- */

    let cachedProducts = JSON.parse(localStorage.getItem("cachedProducts") || "[]");

    function displayMobileProducts(products) {
      const currentLocale = window.Shopify?.locale || document.documentElement.lang || "en";
      recsList.innerHTML = products.map((p) => {
        const title = p.title.length > 18 ? p.title.slice(0, 16) + "..." : p.title;
        const img   = p.images && p.images[0] ? p.images[0].src : "https://via.placeholder.com/80";
        return `
          <li>
            <a href="/${currentLocale}/products/${p.handle}">
              <img src="${img}" alt="${p.title}">
              <span>${title}</span>
            </a>
          </li>
        `;
      }).join("");
    }

    function fetchMobileRecommendations() {
      if (cachedProducts.length) {
        displayMobileProducts(cachedProducts);
      }

      fetch("/collections.json")
        .then((r) => r.json())
        .then((data) => {
          const collections = data.collections || [];
          if (!collections.length) return;

          const tryNext = (attempts = 5) => {
            if (attempts <= 0 || !collections.length) return;
            const random = collections.splice(Math.floor(Math.random() * collections.length), 1)[0];
            fetch(`/collections/${random.handle}/products.json`)
              .then((res) => {
                if (!res.ok) throw new Error();
                return res.json();
              })
              .then((d) => {
                const products = d.products || [];
                if (products.length > 4) {
                  const newProducts = products.sort(() => 0.5 - Math.random()).slice(0, 8);
                  cachedProducts = newProducts;
                  localStorage.setItem("cachedProducts", JSON.stringify(newProducts));
                  displayMobileProducts(newProducts);
                } else {
                  tryNext(attempts - 1);
                }
              })
              .catch(() => tryNext(attempts - 1));
          };

          tryNext();
        })
        .catch(() => {});
    }

    /* ---------- 6. ОТКРЫТЬ / ЗАКРЫТЬ МОДАЛКУ ---------- */

    let searchInModal = false;

    function openModal() {
      if (!isMobile()) return;
      if (searchInModal) return;

      searchInModal = true;

      translateTitles();
      loadHistory();
      fetchMobileRecommendations();

      // переносим блок поиска в модалку
      if (searchSlot && !searchSlot.contains(headerSearch)) {
        searchSlot.appendChild(headerSearch);
      }

      modal.classList.add("is-open");
      document.body.classList.add("clb-mobile-search-open");

      headerInput.focus();
      modal.classList.remove("typing");
    }

    function closeModal() {
      if (headerParent && headerSearch && !headerParent.contains(headerSearch)) {
        headerParent.insertBefore(headerSearch, headerNextSibling);
      }

      modal.classList.remove("is-open", "typing");
      document.body.classList.remove("clb-mobile-search-open");
      searchInModal = false;
    }

    /* ---------- 7. СОБЫТИЯ ---------- */

    function onHeaderSearchTap(e) {
      if (!isMobile()) return;
      if (!searchInModal) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      }
    }

    headerInput.addEventListener("click", onHeaderSearchTap, true);
    headerInput.addEventListener("focus", onHeaderSearchTap, true);

    headerInput.addEventListener("input", function () {
      if (!isMobile()) return;
      const val = headerInput.value.trim();
      if (val.length > 0) {
        modal.classList.add("typing");
      } else {
        modal.classList.remove("typing");
      }
    });

    // клик по "Смотреть все результаты" + клик вне — возвращаем историю
    document.addEventListener("click", function (e) {
      if (!isMobile()) return;
      if (!modal.classList.contains("is-open")) return;

      const viewAllBtn = e.target.closest(
        '.predictive-search__view-all, .predictive-search__button, [data-predictive-search-view-all]'
      );

      if (viewAllBtn) {
        const q = (headerInput.value || "").trim();
        if (q) saveHistory(q);
      }

      const predictivePanel = document.querySelector(".predictive-search");
      const insidePredictive =
        predictivePanel && predictivePanel.contains(e.target);
      const insideInput = headerInput.contains(e.target);

      if (!insidePredictive && !insideInput) {
        modal.classList.remove("typing");
      }
    }, true);

    closeBtn?.addEventListener("click", closeModal);
    modalBackdrop?.addEventListener("click", closeModal);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    historyList.addEventListener("click", function (e) {
      const btn    = e.target.closest("button[data-item]");
      const itemLi = e.target.closest(".clb-search-history-item");
      if (btn) {
        const q = btn.dataset.item;
        let history = JSON.parse(localStorage.getItem("searchHistory") || "[]");
        history = history.filter((x) => x !== q);
        localStorage.setItem("searchHistory", JSON.stringify(history));
        loadHistory();
        return;
      }
      if (itemLi) {
        const q = itemLi.dataset.query;
        headerInput.value = q;
        headerInput.focus();
        modal.classList.add("typing");
      }
    });

    clearHistoryBtn?.addEventListener("click", clearHistory);
  } // конец initMobileSearch

  // ================= ЛЕНИВАЯ ЗАГРУЗКА: СОЗДАЁМ МОДАЛКУ ТОЛЬКО ПРИ ПЕРВОМ КЛИКЕ =================

  function bootMobileOnce(e) {
    if (mobileSearchBooted) return;
    const input = e.target.closest(".js-search-input");
    if (!input) return;
    if (!isMobile()) return;

    mobileSearchBooted = true;

    // больше не слушаем
    document.removeEventListener("click", bootMobileOnce, true);
    document.removeEventListener("focusin", bootMobileOnce, true);

    // создаём модалку и все обработчики
    initMobileSearch();

    // и сразу повторяем клик, чтобы модалка открылась
    input.dispatchEvent(new Event("click", { bubbles: true }));
  }

  document.addEventListener("click",   bootMobileOnce, true);
  document.addEventListener("focusin", bootMobileOnce, true);
});
